import { FaSave } from 'react-icons/fa';
import ToggleControl from './ToggleControl';
import SettingsCard from './SettingsCard';

const normalizeLeagueList = (items = []) => items.flat().filter(Boolean);

const EventsSection = ({
  data,
  autoSelectEnabled,
  onAutoSelectToggle,
  selectedLeagues,
  onLeagueToggle,
  onSave,
  hasChanges = false,
  leagues,
}) => {
  const { title, description, autoSelectLabel, autoSelectDescription, defaultLeagues } = data;
  const defaultLeagueItems = normalizeLeagueList(defaultLeagues);
  const isLeagueSelectionDisabled = !autoSelectEnabled;

  return (
    <SettingsCard title={title} description={description}>
      <ToggleControl
        label={autoSelectLabel}
        description={autoSelectDescription}
        checked={autoSelectEnabled}
        onChange={onAutoSelectToggle}
        className="mb-6"
      />

      <div className="space-y-5">
        <div
          className={`rounded-xl border border-customBorder/40 dark:bg-custom_dark_background/40 bg-customLightMilkWhite px-5 py-6 transition ${
            isLeagueSelectionDisabled ? 'opacity-60' : ''
          }`}
        >
          <div className="grid gap-8 lg:grid-cols-2">
            <div className="space-y-3 max-h-[300px] overflow-y-auto">
              <h3 className="text-sm font-semibold dark:text-customHeading text-background">
                Leagues
              </h3>
              <ul className="grid gap-4 sm:grid-cols-2">
                {leagues.map((league) => {
                  const inputId = `league-${league.id}`;

                  return (
                    <li key={league.id} className="flex items-center gap-3">
                      <input
                        id={inputId}
                        type="checkbox"
                        disabled={isLeagueSelectionDisabled}
                        checked={selectedLeagues.has(league.id)}
                        onChange={() => onLeagueToggle(league)}
                        className="h-5 w-5 rounded-lg border border-customBorder bg-transparent text-customAccent focus:ring-2 focus:ring-customAccent focus:ring-offset-1 focus:ring-offset-settings-surfaceMuted disabled:cursor-not-allowed"
                      />
                      <label htmlFor={inputId} className="text-sm font-medium dark:text-customHeading text-background">
                        {league.label}
                      </label>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="space-y-3">
              <h3 className="text-sm font-semibold dark:text-customHeading text-background">
                Default Leagues
              </h3>
              <ul className="grid gap-4 sm:grid-cols-2">
                {defaultLeagueItems.map((league) => {
                  const inputId = `default-league-${league.id}`;

                  return (
                    <li key={league.id} className="flex items-center gap-3">
                      <input
                        id={inputId}
                        type="checkbox"
                        disabled={isLeagueSelectionDisabled}
                        checked={selectedLeagues.has(league.id)}
                        onChange={() => onLeagueToggle(league)}
                        className="h-5 w-5 rounded-lg border border-customBorder bg-transparent text-customAccent focus:ring-2 focus:ring-customAccent focus:ring-offset-1 focus:ring-offset-settings-surfaceMuted disabled:cursor-not-allowed"
                      />
                      <label htmlFor={inputId} className="text-sm font-medium dark:text-customHeading text-background">
                        {league.label}
                      </label>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>

        <div className="flex justify-end">
          <button
            type="button"
            onClick={onSave}
            disabled={!hasChanges}
            className="inline-flex items-center justify-center gap-2 rounded-full bg-customAccent px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-customAccent/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-customAccent focus-visible:ring-offset-2 focus-visible:ring-offset-customSurface disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-customAccent"
          >
            <FaSave className="h-4 w-4" aria-hidden="true" />
            Save Changes
          </button>
        </div>
      </div>
    </SettingsCard>
  );
};

export default EventsSection;
